import { useConfig } from 'shared/config/ConfigContext';

import type { ResultItem } from '@/domain';
import { resultItemLocationString, resultItemPriceString } from '@/utils/formatting';

export interface MapCardProps {
    selectedAd: ResultItem | null;
    closeCard: () => void;
}

export const MapCard = ({ selectedAd, closeCard }: MapCardProps) => {
    const { contextPath } = useConfig();

    if (selectedAd === null) {
        return null;
    }

    const url = `${contextPath}/ad.html?finnkode=${selectedAd?.id}`;

    return (
        <article className="maplibregl-ctrl map-card inline-block bg-white rounded-8">
            <a className="map-result-list-item-link" data-testid="mapCardLink" href={url} target="_blank" rel="noreferrer">
                <div className="map-card-image img-format img-format--centered m-16 w-1/3">
                    <img src={selectedAd?.imageurl} className="img-format__img u-border-radius-8px" alt="" />
                </div>
                <div className="map-card-details w-2/3">
                    <div>
                        <div className="text-14 truncate my-8">{resultItemLocationString(selectedAd)}</div>
                        <h3 className="map-card-name two-line-ellipsis text-16">{selectedAd?.heading}</h3>
                        {resultItemPriceString(selectedAd)}
                    </div>
                </div>
            </a>
            <button
                aria-label="Lukk"
                title="Lukk"
                type="button"
                data-testid="closeButton"
                className="map-card-close-button"
                onClick={closeCard}>
                <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" color="#474445">
                    <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 8L4.46 4.46 8 8l3.54-3.54L8 8zm0 0l3.54 3.54L8 8l-3.54 3.54L8 8z"
                    />
                </svg>
            </button>
        </article>
    );
};
